import MyWorkModel from '../../gd-model/my-work/my-work-model';
import EventActionProto from '../event-action-proto';

const debug = false
// const debug = "EventMyWorkNew"

class EventMyWorkNew extends EventActionProto {

    constructor(uid, data, sid, companyId) {
        super(uid, data, companyId);
    }


    process() {
        if (!gd.session.myWork) return;

        if (this.companyId && this.companyId!==gd.companyId) return false;

        const newModel = new MyWorkModel(this.data,{parse:true});
        gd.session.myWork.add(newModel,{
            silent:false
        });
        gd.bus.triggerEvent('gd.session.myWork:add');

        debug && console.log(debug, "process", this.data)

        // temporary solution for new my work (for dateCreated, isNew and fromUserId)
        if (this.data.task) {
            gd.modelBus.newUpdate('my-work-task', 'new', this.data.task.id, _.assign({}, this.data.task, {
                properties: {
                    'myWork'    : {
                        'actionRequired': {
                            sinceMoment : this.data.dateCreated,
                            isNew       : this.data.isNew,
                            fromUserId  : this.data.fromUserId,
                        }
                    }
                }
            }), {
                task        : this.data.task,
                isBulkUpdate: true,
            })
        }

        // temporary solution for new my work event
        if (this.data.event) {
            gd.modelBus.newUpdate('event', 'new', this.data.event.id, _.assign({}, this.data.event), {
                event       : this.data.event,
                isBulkUpdate: true,
            })
        }

    }

}

module.exports = EventMyWorkNew;
